import React from "react";
import { Spinner } from "reactstrap";
import "./StatusIndicator.scss";

function StatusIndicator({ status, message, size = "normal" }) {
  let messageClass = "text-primary";
  let indicator = null;
  switch (status) {
    case "success":
      indicator = <i className="fas fa-check-circle text-success" />;
      messageClass = "text-success";
      break;
    case "failed":
      indicator = <i className="fas fa-times text-danger" />;
      messageClass = "text-danger";
      break;
    case "warning":
      // Display warning with orange color and warning icon
      indicator = <i className="fas fa-exclamation-triangle text-warning" />;
      messageClass = "text-warning";
      break;
    case "progress":
      indicator = <Spinner color="success" className="s" />;
      messageClass = "text-success";
      break;
    default:
      indicator = null;
  }

  const rootClassName = size === "small" ? "status-indicator status-indicator--small" : "status-indicator";

  return (
    <div className={rootClassName}>
      {indicator} <span className={messageClass}>{message}</span>
    </div>
  );
}

export default StatusIndicator;
